import "./main.css";
import {Item as $5ae296f2d6923e14$re_export$Item, Section as $5ae296f2d6923e14$re_export$Section, getChildNodes as $9SHwR$getChildNodes} from "@react-stately/collections";
import {useDOMRef as $9SHwR$useDOMRef, useIsMobileDevice as $9SHwR$useIsMobileDevice, classNames as $9SHwR$classNames, SlotProvider as $9SHwR$SlotProvider, useStyleProps as $9SHwR$useStyleProps, ClearSlots as $9SHwR$ClearSlots, useSlotProps as $9SHwR$useSlotProps, unwrapDOMRef as $9SHwR$unwrapDOMRef} from "@react-spectrum/utils";
import {Tray as $9SHwR$Tray, Popover as $9SHwR$Popover} from "@react-spectrum/overlays";
import {PressResponder as $9SHwR$PressResponder, useInteractOutside as $9SHwR$useInteractOutside, getInteractionModality as $9SHwR$getInteractionModality} from "@react-aria/interactions";
import $9SHwR$react, {useRef as $9SHwR$useRef, Fragment as $9SHwR$Fragment, forwardRef as $9SHwR$forwardRef, useContext as $9SHwR$useContext, useState as $9SHwR$useState, useEffect as $9SHwR$useEffect, useMemo as $9SHwR$useMemo} from "react";
import {useMenuTrigger as $9SHwR$useMenuTrigger, UNSTABLE_useSubmenuTrigger as $9SHwR$UNSTABLE_useSubmenuTrigger, useMenu as $9SHwR$useMenu, useMenuItem as $9SHwR$useMenuItem, useMenuSection as $9SHwR$useMenuSection} from "@react-aria/menu";
import {useMenuTriggerState as $9SHwR$useMenuTriggerState, UNSTABLE_useSubmenuTriggerState as $9SHwR$UNSTABLE_useSubmenuTriggerState} from "@react-stately/menu";
import {useLayoutEffect as $9SHwR$useLayoutEffect, mergeProps as $9SHwR$mergeProps, useSyncRef as $9SHwR$useSyncRef, useSlotId as $9SHwR$useSlotId, useObjectRef as $9SHwR$useObjectRef, mergeRefs as $9SHwR$mergeRefs, filterDOMProps as $9SHwR$filterDOMProps} from "@react-aria/utils";
import $9SHwR$reactdom from "react-dom";
import {useLocale as $9SHwR$useLocale, useLocalizedStringFormatter as $9SHwR$useLocalizedStringFormatter} from "@react-aria/i18n";
import {ActionButton as $9SHwR$ActionButton} from "@react-spectrum/button";
import $9SHwR$spectrumiconsuiArrowDownSmall from "@spectrum-icons/ui/ArrowDownSmall";
import {FocusScope as $9SHwR$FocusScope, FocusRing as $9SHwR$FocusRing} from "@react-aria/focus";
import {useTreeState as $9SHwR$useTreeState} from "@react-stately/tree";
import $9SHwR$spectrumiconsuiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import $9SHwR$spectrumiconsworkflowChevronLeft from "@spectrum-icons/workflow/ChevronLeft";
import $9SHwR$spectrumiconsworkflowChevronRight from "@spectrum-icons/workflow/ChevronRight";
import {Grid as $9SHwR$Grid} from "@react-spectrum/layout";
import $9SHwR$spectrumiconsworkflowInfoOutline from "@spectrum-icons/workflow/InfoOutline";
import {Text as $9SHwR$Text} from "@react-spectrum/text";
import {useSeparator as $9SHwR$useSeparator} from "@react-aria/separator";
import $9SHwR$spectrumiconsworkflowMore from "@spectrum-icons/workflow/More";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $d94604d52c3e3feb$export$c7e742effb1c51e2 = (0, $9SHwR$react).createContext({});
function $d94604d52c3e3feb$export$21c7ab35b39f78ec() {
    return (0, $9SHwR$useContext)($d94604d52c3e3feb$export$c7e742effb1c51e2);
}
const $d94604d52c3e3feb$export$8d97fe02339fc0e3 = (0, $9SHwR$react).createContext(undefined);
function $d94604d52c3e3feb$export$dc2161044aa0b36d() {
    return (0, $9SHwR$useContext)($d94604d52c3e3feb$export$8d97fe02339fc0e3);
}
const $d94604d52c3e3feb$export$24aad8519b95b41b = (0, $9SHwR$react).createContext(undefined);
function $d94604d52c3e3feb$export$efa3856fc0e85e7f() {
    return (0, $9SHwR$useContext)($d94604d52c3e3feb$export$24aad8519b95b41b);
}





var $286d1cb34bb7dc84$exports = {};

$parcel$export($286d1cb34bb7dc84$exports, "checkmark", () => $286d1cb34bb7dc84$export$292abbf31ed842a, (v) => $286d1cb34bb7dc84$export$292abbf31ed842a = v);
$parcel$export($286d1cb34bb7dc84$exports, "chevron", () => $286d1cb34bb7dc84$export$980c1089c0604ea3, (v) => $286d1cb34bb7dc84$export$980c1089c0604ea3 = v);
$parcel$export($286d1cb34bb7dc84$exports, "description", () => $286d1cb34bb7dc84$export$6d59db4903f20f7d, (v) => $286d1cb34bb7dc84$export$6d59db4903f20f7d = v);
$parcel$export($286d1cb34bb7dc84$exports, "end", () => $286d1cb34bb7dc84$export$bd5df0f255a350f8, (v) => $286d1cb34bb7dc84$export$bd5df0f255a350f8 = v);
$parcel$export($286d1cb34bb7dc84$exports, "focus-ring", () => $286d1cb34bb7dc84$export$f39a09f249340e2a, (v) => $286d1cb34bb7dc84$export$f39a09f249340e2a = v);
$parcel$export($286d1cb34bb7dc84$exports, "i18nFontFamily", () => $286d1cb34bb7dc84$export$8c4ee2c50c22c514, (v) => $286d1cb34bb7dc84$export$8c4ee2c50c22c514 = v);
$parcel$export($286d1cb34bb7dc84$exports, "icon", () => $286d1cb34bb7dc84$export$1ca1ec8b29a4ce27, (v) => $286d1cb34bb7dc84$export$1ca1ec8b29a4ce27 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-active", () => $286d1cb34bb7dc84$export$20fd0f7cd4e6112f, (v) => $286d1cb34bb7dc84$export$20fd0f7cd4e6112f = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-disabled", () => $286d1cb34bb7dc84$export$d35bc1e505d1ebbf, (v) => $286d1cb34bb7dc84$export$d35bc1e505d1ebbf = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-expanded", () => $286d1cb34bb7dc84$export$911ebb89bba4b634, (v) => $286d1cb34bb7dc84$export$911ebb89bba4b634 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-focused", () => $286d1cb34bb7dc84$export$e7dc768d35940237, (v) => $286d1cb34bb7dc84$export$e7dc768d35940237 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-highlighted", () => $286d1cb34bb7dc84$export$451c613d0772eb99, (v) => $286d1cb34bb7dc84$export$451c613d0772eb99 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-hovered", () => $286d1cb34bb7dc84$export$b8813cd5d7824ce7, (v) => $286d1cb34bb7dc84$export$b8813cd5d7824ce7 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-open", () => $286d1cb34bb7dc84$export$a9781837241c946d, (v) => $286d1cb34bb7dc84$export$a9781837241c946d = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-selectable", () => $286d1cb34bb7dc84$export$fbd22ba224473193, (v) => $286d1cb34bb7dc84$export$fbd22ba224473193 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-selected", () => $286d1cb34bb7dc84$export$1e0fb04f31d3c22a, (v) => $286d1cb34bb7dc84$export$1e0fb04f31d3c22a = v);
$parcel$export($286d1cb34bb7dc84$exports, "keyboard", () => $286d1cb34bb7dc84$export$cfdd767f5a513509, (v) => $286d1cb34bb7dc84$export$cfdd767f5a513509 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-FocusRing-ring", () => $286d1cb34bb7dc84$export$4109102f950813a6, (v) => $286d1cb34bb7dc84$export$4109102f950813a6 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-FocusRing", () => $286d1cb34bb7dc84$export$24c7f46a6e3605dd, (v) => $286d1cb34bb7dc84$export$24c7f46a6e3605dd = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-FocusRing--quiet", () => $286d1cb34bb7dc84$export$2927016961429360, (v) => $286d1cb34bb7dc84$export$2927016961429360 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Icon", () => $286d1cb34bb7dc84$export$d374b04f30360026, (v) => $286d1cb34bb7dc84$export$d374b04f30360026 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu", () => $286d1cb34bb7dc84$export$fae6af6decd50ac5, (v) => $286d1cb34bb7dc84$export$fae6af6decd50ac5 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-avatar", () => $286d1cb34bb7dc84$export$944daf9b7d423a02, (v) => $286d1cb34bb7dc84$export$944daf9b7d423a02 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-checkmark", () => $286d1cb34bb7dc84$export$8e15a726e4f7e62d, (v) => $286d1cb34bb7dc84$export$8e15a726e4f7e62d = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-chevron", () => $286d1cb34bb7dc84$export$ca45e0db366b8e6c, (v) => $286d1cb34bb7dc84$export$ca45e0db366b8e6c = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-description", () => $286d1cb34bb7dc84$export$36f1275051e39ead, (v) => $286d1cb34bb7dc84$export$36f1275051e39ead = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-divider", () => $286d1cb34bb7dc84$export$e892026f534efed8, (v) => $286d1cb34bb7dc84$export$e892026f534efed8 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-end", () => $286d1cb34bb7dc84$export$926a1bb74ed65667, (v) => $286d1cb34bb7dc84$export$926a1bb74ed65667 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-icon", () => $286d1cb34bb7dc84$export$cbbae63ef9e44c7a, (v) => $286d1cb34bb7dc84$export$cbbae63ef9e44c7a = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-item", () => $286d1cb34bb7dc84$export$45faad328e6c532b, (v) => $286d1cb34bb7dc84$export$45faad328e6c532b = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemGrid", () => $286d1cb34bb7dc84$export$ee5f52784f57f9c8, (v) => $286d1cb34bb7dc84$export$ee5f52784f57f9c8 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemIcon", () => $286d1cb34bb7dc84$export$f431001e1bb54633, (v) => $286d1cb34bb7dc84$export$f431001e1bb54633 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemLabel", () => $286d1cb34bb7dc84$export$1aa6419c5c650567, (v) => $286d1cb34bb7dc84$export$1aa6419c5c650567 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemLabel--wrapping", () => $286d1cb34bb7dc84$export$465092164a8e1d98, (v) => $286d1cb34bb7dc84$export$465092164a8e1d98 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-keyboard", () => $286d1cb34bb7dc84$export$4f9817a7dff6ba0f, (v) => $286d1cb34bb7dc84$export$4f9817a7dff6ba0f = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-popover", () => $286d1cb34bb7dc84$export$d959f30786125b, (v) => $286d1cb34bb7dc84$export$d959f30786125b = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-section--isFirst", () => $286d1cb34bb7dc84$export$dae331c15950f1e, (v) => $286d1cb34bb7dc84$export$dae331c15950f1e = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-section--isLast", () => $286d1cb34bb7dc84$export$9778864c5b622fbc, (v) => $286d1cb34bb7dc84$export$9778864c5b622fbc = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-section--noHeading", () => $286d1cb34bb7dc84$export$8b61ec49b96ad17e, (v) => $286d1cb34bb7dc84$export$8b61ec49b96ad17e = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-sectionHeading", () => $286d1cb34bb7dc84$export$c20ea4b35020fbdd, (v) => $286d1cb34bb7dc84$export$c20ea4b35020fbdd = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-subdialog", () => $286d1cb34bb7dc84$export$d7e47bfca92b5744, (v) => $286d1cb34bb7dc84$export$d7e47bfca92b5744 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-wrapper", () => $286d1cb34bb7dc84$export$76d36e55740ad742, (v) => $286d1cb34bb7dc84$export$76d36e55740ad742 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-wrapper--isMobile", () => $286d1cb34bb7dc84$export$c873119be41fdb72, (v) => $286d1cb34bb7dc84$export$c873119be41fdb72 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Submenu-heading", () => $286d1cb34bb7dc84$export$c830d2588e34dae1, (v) => $286d1cb34bb7dc84$export$c830d2588e34dae1 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Submenu-headingWrapper", () => $286d1cb34bb7dc84$export$d3fc690f61339a08, (v) => $286d1cb34bb7dc84$export$d3fc690f61339a08 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Submenu-popover", () => $286d1cb34bb7dc84$export$fe967dac6207a986, (v) => $286d1cb34bb7dc84$export$fe967dac6207a986 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Submenu-wrapper", () => $286d1cb34bb7dc84$export$158cbd6607d36c4e, (v) => $286d1cb34bb7dc84$export$158cbd6607d36c4e = v);
$parcel$export($286d1cb34bb7dc84$exports, "text", () => $286d1cb34bb7dc84$export$6f093cfa640b7166, (v) => $286d1cb34bb7dc84$export$6f093cfa640b7166 = v);
var $286d1cb34bb7dc84$export$292abbf31ed842a;
var $286d1cb34bb7dc84$export$980c1089c0604ea3;
var $286d1cb34bb7dc84$export$6d59db4903f20f7d;
var $286d1cb34bb7dc84$export$bd5df0f255a350f8;
var $286d1cb34bb7dc84$export$f39a09f249340e2a;
var $286d1cb34bb7dc84$export$8c4ee2c50c22c514;
var $286d1cb34bb7dc84$export$1ca1ec8b29a4ce27;
var $286d1cb34bb7dc84$export$20fd0f7cd4e6112f;
var $286d1cb34bb7dc84$export$d35bc1e505d1ebbf;
var $286d1cb34bb7dc84$export$911ebb89bba4b634;
var $286d1cb34bb7dc84$export$e7dc768d35940237;
var $286d1cb34bb7dc84$export$451c613d0772eb99;
var $286d1cb34bb7dc84$export$b8813cd5d7824ce7;
var $286d1cb34bb7dc84$export$a9781837241c946d;
var $286d1cb34bb7dc84$export$fbd22ba224473193;
var $286d1cb34bb7dc84$export$1e0fb04f31d3c22a;
var $286d1cb34bb7dc84$export$cfdd767f5a513509;
var $286d1cb34bb7dc84$export$4109102f950813a6;
var $286d1cb34bb7dc84$export$24c7f46a6e3605dd;
var $286d1cb34bb7dc84$export$2927016961429360;
var $286d1cb34bb7dc84$export$d374b04f30360026;
var $286d1cb34bb7dc84$export$fae6af6decd50ac5;
var $286d1cb34bb7dc84$export$944daf9b7d423a02;
var $286d1cb34bb7dc84$export$8e15a726e4f7e62d;
var $286d1cb34bb7dc84$export$ca45e0db366b8e6c;
var $286d1cb34bb7dc84$export$36f1275051e39ead;
var $286d1cb34bb7dc84$export$e892026f534efed8;
var $286d1cb34bb7dc84$export$926a1bb74ed65667;
var $286d1cb34bb7dc84$export$cbbae63ef9e44c7a;
var $286d1cb34bb7dc84$export$45faad328e6c532b;
var $286d1cb34bb7dc84$export$ee5f52784f57f9c8;
var $286d1cb34bb7dc84$export$f431001e1bb54633;
var $286d1cb34bb7dc84$export$1aa6419c5c650567;
var $286d1cb34bb7dc84$export$465092164a8e1d98;
var $286d1cb34bb7dc84$export$4f9817a7dff6ba0f;
var $286d1cb34bb7dc84$export$d959f30786125b;
var $286d1cb34bb7dc84$export$dae331c15950f1e;
var $286d1cb34bb7dc84$export$9778864c5b622fbc;
var $286d1cb34bb7dc84$export$8b61ec49b96ad17e;
var $286d1cb34bb7dc84$export$c20ea4b35020fbdd;
var $286d1cb34bb7dc84$export$d7e47bfca92b5744;
var $286d1cb34bb7dc84$export$76d36e55740ad742;
var $286d1cb34bb7dc84$export$c873119be41fdb72;
var $286d1cb34bb7dc84$export$c830d2588e34dae1;
var $286d1cb34bb7dc84$export$d3fc690f61339a08;
var $286d1cb34bb7dc84$export$fe967dac6207a986;
var $286d1cb34bb7dc84$export$158cbd6607d36c4e;
var $286d1cb34bb7dc84$export$6f093cfa640b7166;
$286d1cb34bb7dc84$export$292abbf31ed842a = `Q7FggG_checkmark`;
$286d1cb34bb7dc84$export$980c1089c0604ea3 = `Q7FggG_chevron`;
$286d1cb34bb7dc84$export$6d59db4903f20f7d = `Q7FggG_description`;
$286d1cb34bb7dc84$export$bd5df0f255a350f8 = `Q7FggG_end`;
$286d1cb34bb7dc84$export$f39a09f249340e2a = `Q7FggG_focus-ring`;
$286d1cb34bb7dc84$export$8c4ee2c50c22c514 = `Q7FggG_i18nFontFamily`;
$286d1cb34bb7dc84$export$1ca1ec8b29a4ce27 = `Q7FggG_icon`;
$286d1cb34bb7dc84$export$20fd0f7cd4e6112f = `Q7FggG_is-active`;
$286d1cb34bb7dc84$export$d35bc1e505d1ebbf = `Q7FggG_is-disabled`;
$286d1cb34bb7dc84$export$911ebb89bba4b634 = `Q7FggG_is-expanded`;
$286d1cb34bb7dc84$export$e7dc768d35940237 = `Q7FggG_is-focused`;
$286d1cb34bb7dc84$export$451c613d0772eb99 = `Q7FggG_is-highlighted`;
$286d1cb34bb7dc84$export$b8813cd5d7824ce7 = `Q7FggG_is-hovered`;
$286d1cb34bb7dc84$export$a9781837241c946d = `Q7FggG_is-open`;
$286d1cb34bb7dc84$export$fbd22ba224473193 = `Q7FggG_is-selectable`;
$286d1cb34bb7dc84$export$1e0fb04f31d3c22a = `Q7FggG_is-selected`;
$286d1cb34bb7dc84$export$cfdd767f5a513509 = `Q7FggG_keyboard`;
$286d1cb34bb7dc84$export$4109102f950813a6 = `Q7FggG_spectrum-FocusRing-ring`;
$286d1cb34bb7dc84$export$24c7f46a6e3605dd = `Q7FggG_spectrum-FocusRing ${$286d1cb34bb7dc84$export$4109102f950813a6}`;
$286d1cb34bb7dc84$export$2927016961429360 = `Q7FggG_spectrum-FocusRing--quiet`;
$286d1cb34bb7dc84$export$d374b04f30360026 = `Q7FggG_spectrum-Icon`;
$286d1cb34bb7dc84$export$fae6af6decd50ac5 = `Q7FggG_spectrum-Menu`;
$286d1cb34bb7dc84$export$944daf9b7d423a02 = `Q7FggG_spectrum-Menu-avatar`;
$286d1cb34bb7dc84$export$8e15a726e4f7e62d = `Q7FggG_spectrum-Menu-checkmark`;
$286d1cb34bb7dc84$export$ca45e0db366b8e6c = `Q7FggG_spectrum-Menu-chevron`;
$286d1cb34bb7dc84$export$36f1275051e39ead = `Q7FggG_spectrum-Menu-description`;
$286d1cb34bb7dc84$export$e892026f534efed8 = `Q7FggG_spectrum-Menu-divider`;
$286d1cb34bb7dc84$export$926a1bb74ed65667 = `Q7FggG_spectrum-Menu-end`;
$286d1cb34bb7dc84$export$cbbae63ef9e44c7a = `Q7FggG_spectrum-Menu-icon`;
$286d1cb34bb7dc84$export$45faad328e6c532b = `Q7FggG_spectrum-Menu-item`;
$286d1cb34bb7dc84$export$ee5f52784f57f9c8 = `Q7FggG_spectrum-Menu-itemGrid`;
$286d1cb34bb7dc84$export$f431001e1bb54633 = `Q7FggG_spectrum-Menu-itemIcon`;
$286d1cb34bb7dc84$export$1aa6419c5c650567 = `Q7FggG_spectrum-Menu-itemLabel`;
$286d1cb34bb7dc84$export$465092164a8e1d98 = `Q7FggG_spectrum-Menu-itemLabel--wrapping`;
$286d1cb34bb7dc84$export$4f9817a7dff6ba0f = `Q7FggG_spectrum-Menu-keyboard`;
$286d1cb34bb7dc84$export$d959f30786125b = `Q7FggG_spectrum-Menu-popover`;
$286d1cb34bb7dc84$export$dae331c15950f1e = `Q7FggG_spectrum-Menu-section--isFirst`;
$286d1cb34bb7dc84$export$9778864c5b622fbc = `Q7FggG_spectrum-Menu-section--isLast`;
$286d1cb34bb7dc84$export$8b61ec49b96ad17e = `Q7FggG_spectrum-Menu-section--noHeading`;
$286d1cb34bb7dc84$export$c20ea4b35020fbdd = `Q7FggG_spectrum-Menu-sectionHeading`;
$286d1cb34bb7dc84$export$d7e47bfca92b5744 = `Q7FggG_spectrum-Menu-subdialog`;
$286d1cb34bb7dc84$export$76d36e55740ad742 = `Q7FggG_spectrum-Menu-wrapper`;
$286d1cb34bb7dc84$export$c873119be41fdb72 = `Q7FggG_spectrum-Menu-wrapper--isMobile`;
$286d1cb34bb7dc84$export$c830d2588e34dae1 = `Q7FggG_spectrum-Submenu-heading`;
$286d1cb34bb7dc84$export$d3fc690f61339a08 = `Q7FggG_spectrum-Submenu-headingWrapper`;
$286d1cb34bb7dc84$export$fe967dac6207a986 = `Q7FggG_spectrum-Submenu-popover`;
$286d1cb34bb7dc84$export$158cbd6607d36c4e = `Q7FggG_spectrum-Submenu-wrapper`;
$286d1cb34bb7dc84$export$6f093cfa640b7166 = `Q7FggG_text`;




function $aa0b855f135b86e3$var$MenuTrigger(props, ref) {
    let triggerRef = (0, $9SHwR$useRef)();
    let domRef = (0, $9SHwR$useDOMRef)(ref);
    let menuTriggerRef = domRef || triggerRef;
    let menuRef = (0, $9SHwR$useRef)();
    let { children: children, align: align = "start", shouldFlip: shouldFlip = true, direction: direction = "bottom", closeOnSelect: closeOnSelect, trigger: trigger = "press" } = props;
    let [menuTrigger, menu] = (0, $9SHwR$react).Children.toArray(children);
    let state = (0, $9SHwR$useMenuTriggerState)(props);
    let { menuTriggerProps: menuTriggerProps, menuProps: menuProps } = (0, $9SHwR$useMenuTrigger)({
        trigger: trigger
    }, state, menuTriggerRef);
    let initialPlacement;
    switch(direction){
        case "left":
        case "right":
        case "start":
        case "end":
            initialPlacement = `${direction} ${align === "end" ? "bottom" : "top"}`;
            break;
        case "bottom":
        case "top":
        default:
            initialPlacement = `${direction} ${align}`;
    }
    let isMobile = (0, $9SHwR$useIsMobileDevice)();
    let menuContext = {
        ...menuProps,
        ref: menuRef,
        onClose: state.close,
        closeOnSelect: closeOnSelect,
        autoFocus: state.focusStrategy || true,
        UNSAFE_style: isMobile ? {
            width: "100%",
            maxHeight: "inherit"
        } : undefined,
        UNSAFE_className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), {
            "spectrum-Menu-popover": !isMobile
        }),
        state: state
    };
    // On small screen devices, the menu is rendered in a tray, otherwise a popover.
    let overlay;
    if (isMobile) overlay = /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$Tray), {
        state: state,
        isFixedHeight: true
    }, menu);
    else overlay = /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$Popover), {
        UNSAFE_style: {
            clipPath: "unset",
            overflow: "visible",
            filter: "unset",
            borderWidth: "0px"
        },
        state: state,
        triggerRef: menuTriggerRef,
        scrollRef: menuRef,
        placement: initialPlacement,
        hideArrow: true,
        shouldFlip: shouldFlip
    }, menu);
    return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$Fragment), null, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$SlotProvider), {
        slots: {
            actionButton: {
                holdAffordance: trigger === "longPress"
            }
        }
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$PressResponder), {
        ...menuTriggerProps,
        ref: menuTriggerRef,
        isPressed: state.isOpen
    }, menuTrigger)), /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $d94604d52c3e3feb$export$c7e742effb1c51e2).Provider, {
        value: menuContext
    }, overlay));
}
/**
 * The MenuTrigger serves as a wrapper around a Menu and its associated trigger,
 * linking the Menu's open state with the trigger's press state.
 */ let $aa0b855f135b86e3$export$27d2ad3c5815583e = /*#__PURE__*/ (0, $9SHwR$forwardRef)($aa0b855f135b86e3$var$MenuTrigger);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 









function $3f13e15cf95c3893$var$SubmenuTrigger(props) {
    let triggerRef = (0, $9SHwR$useRef)();
    let { children: children, targetKey: targetKey } = props;
    let [menuTrigger, menu] = (0, $9SHwR$react).Children.toArray(children);
    let { popoverContainer: popoverContainer, trayContainerRef: trayContainerRef, menu: parentMenuRef, submenu: menuRef, rootMenuTriggerState: rootMenuTriggerState, state: state } = (0, $d94604d52c3e3feb$export$efa3856fc0e85e7f)();
    let triggerNode = state.collection.getItem(targetKey);
    let submenuTriggerState = (0, $9SHwR$UNSTABLE_useSubmenuTriggerState)({
        triggerKey: targetKey
    }, rootMenuTriggerState);
    let { submenuTriggerProps: submenuTriggerProps, submenuProps: submenuProps, popoverProps: popoverProps } = (0, $9SHwR$UNSTABLE_useSubmenuTrigger)({
        node: triggerNode,
        parentMenuRef: parentMenuRef,
        submenuRef: menuRef
    }, submenuTriggerState, triggerRef);
    let isMobile = (0, $9SHwR$useIsMobileDevice)();
    let onBackButtonPress = ()=>{
        submenuTriggerState.close();
        if (parentMenuRef.current && !parentMenuRef.current.contains(document.activeElement)) parentMenuRef.current.focus();
    };
    let { direction: direction } = (0, $9SHwR$useLocale)();
    let mobileSubmenuKeyDown = (e)=>{
        switch(e.key){
            case "ArrowLeft":
                if (direction === "ltr") triggerRef.current.focus();
                break;
            case "ArrowRight":
                if (direction === "rtl") triggerRef.current.focus();
                break;
        }
    };
    let overlay;
    let [offset, setOffset] = (0, $9SHwR$useState)(0);
    (0, $9SHwR$useLayoutEffect)(()=>{
        if (parentMenuRef.current) {
            var _window_getComputedStyle, _window;
            let offset = (_window = window) === null || _window === void 0 ? void 0 : (_window_getComputedStyle = _window.getComputedStyle(parentMenuRef === null || parentMenuRef === void 0 ? void 0 : parentMenuRef.current)) === null || _window_getComputedStyle === void 0 ? void 0 : _window_getComputedStyle.getPropertyValue("--spectrum-submenu-offset-distance");
            if (offset !== "") setOffset(-1 * parseInt(offset, 10));
        }
    }, [
        parentMenuRef
    ]);
    if (isMobile) {
        var _submenuProps;
        delete submenuTriggerProps.onBlur;
        delete submenuTriggerProps.onHoverChange;
        var _autoFocus;
        (_autoFocus = (_submenuProps = submenuProps).autoFocus) !== null && _autoFocus !== void 0 ? _autoFocus : _submenuProps.autoFocus = true;
        if (trayContainerRef.current && submenuTriggerState.isOpen) overlay = /*#__PURE__*/ (0, $9SHwR$reactdom).createPortal(menu, trayContainerRef.current);
    } else {
        let onDismissButtonPress = ()=>{
            var _parentMenuRef_current;
            submenuTriggerState.close();
            (_parentMenuRef_current = parentMenuRef.current) === null || _parentMenuRef_current === void 0 ? void 0 : _parentMenuRef_current.focus();
        };
        overlay = /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$Popover), {
            ...popoverProps,
            onDismissButtonPress: onDismissButtonPress,
            UNSAFE_className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Submenu-popover"),
            container: popoverContainer,
            containerPadding: 0,
            crossOffset: offset,
            offset: offset,
            enableBothDismissButtons: true,
            UNSAFE_style: {
                clipPath: "unset",
                overflow: "visible",
                borderWidth: "0px"
            },
            state: submenuTriggerState,
            triggerRef: triggerRef,
            scrollRef: menuRef,
            placement: "end top",
            hideArrow: true
        }, menu);
    }
    let menuContext = {
        ...(0, $9SHwR$mergeProps)(submenuProps, {
            ref: menuRef,
            UNSAFE_style: isMobile ? {
                width: "100%",
                maxHeight: "inherit"
            } : undefined,
            UNSAFE_className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), {
                "spectrum-Menu-popover": !isMobile
            }),
            ...isMobile && {
                onBackButtonPress: onBackButtonPress,
                onKeyDown: mobileSubmenuKeyDown
            }
        })
    };
    return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$react).Fragment, null, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $d94604d52c3e3feb$export$8d97fe02339fc0e3).Provider, {
        value: {
            triggerRef: triggerRef,
            ...submenuTriggerProps
        }
    }, menuTrigger), /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $d94604d52c3e3feb$export$c7e742effb1c51e2).Provider, {
        value: menuContext
    }, overlay));
}
$3f13e15cf95c3893$var$SubmenuTrigger.getCollectionNode = function*(props) {
    let childArray = [];
    (0, $9SHwR$react).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, $9SHwR$react).isValidElement(child)) childArray.push(child);
    });
    let [trigger] = childArray;
    let [, content] = props.children;
    yield {
        element: /*#__PURE__*/ (0, $9SHwR$react).cloneElement(trigger, {
            ...trigger.props,
            hasChildItems: true,
            isTrigger: true
        }),
        wrapper: (element)=>/*#__PURE__*/ (0, $9SHwR$react).createElement($3f13e15cf95c3893$var$SubmenuTrigger, {
                key: element.key,
                targetKey: element.key,
                ...props
            }, element, content)
    };
};
let $3f13e15cf95c3893$export$ecabc99eeffab7ca = $3f13e15cf95c3893$var$SubmenuTrigger;


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



var $90339528ca3fdd88$exports = {};
var $9c47fa309a7d4d43$exports = {};
$9c47fa309a7d4d43$exports = {
    "backButton": (args)=>`\u{627}\u{644}\u{631}\u{62C}\u{648}\u{639} \u{625}\u{644}\u{649} ${args.prevMenuButton}`,
    "moreActions": `\u{627}\u{644}\u{645}\u{632}\u{64A}\u{62F} \u{645}\u{646} \u{627}\u{644}\u{625}\u{62C}\u{631}\u{627}\u{621}\u{627}\u{62A}`,
    "unavailable": `\u{63A}\u{64A}\u{631} \u{645}\u{64F}\u{62A}\u{648}\u{641}\u{631}\u{60C} \u{642}\u{64F}\u{645} \u{628}\u{627}\u{644}\u{62A}\u{648}\u{633}\u{64A}\u{639} \u{644}\u{644}\u{62D}\u{635}\u{648}\u{644} \u{639}\u{644}\u{649} \u{627}\u{644}\u{62A}\u{641}\u{627}\u{635}\u{64A}\u{644}`
};


var $4cd8d8b72a119260$exports = {};
$4cd8d8b72a119260$exports = {
    "backButton": (args)=>`\u{41D}\u{430}\u{437}\u{430}\u{434} \u{43A}\u{44A}\u{43C} ${args.prevMenuButton}`,
    "moreActions": `\u{41F}\u{43E}\u{432}\u{435}\u{447}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{44A}\u{43F}\u{43D}\u{43E}, \u{440}\u{430}\u{437}\u{433}\u{44A}\u{43D}\u{435}\u{442}\u{435} \u{437}\u{430} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438}`
};


var $10556a59bf2ddefc$exports = {};
$10556a59bf2ddefc$exports = {
    "backButton": (args)=>`N\xe1vrat na ${args.prevMenuButton}`,
    "moreActions": `Dal\u{161}\xed akce`,
    "unavailable": `Nen\xed k dispozici, rozbalen\xedm zobraz\xedte podrobnosti`
};


var $c31b6134a3770ee4$exports = {};
$c31b6134a3770ee4$exports = {
    "backButton": (args)=>`Vend tilbage til ${args.prevMenuButton}`,
    "moreActions": `Flere handlinger`,
    "unavailable": `Ikke tilg\xe6ngelig, udvid for detaljer`
};


var $16c606e9b72a71c3$exports = {};
$16c606e9b72a71c3$exports = {
    "backButton": (args)=>`Zur\xfcck zu ${args.prevMenuButton}`,
    "moreActions": `Mehr Aktionen`,
    "unavailable": `Nicht verf\xfcgbar, f\xfcr Details erweitern`
};


var $055104befa589c0a$exports = {};
$055104befa589c0a$exports = {
    "backButton": (args)=>`\u{395}\u{3C0}\u{3B9}\u{3C3}\u{3C4}\u{3C1}\u{3BF}\u{3C6}\u{3AE} \u{3C3}\u{3C4}\u{3BF} ${args.prevMenuButton}`,
    "moreActions": `\u{3A0}\u{3B5}\u{3C1}\u{3B9}\u{3C3}\u{3C3}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B5}\u{3C2} \u{3B5}\u{3BD}\u{3AD}\u{3C1}\u{3B3}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`,
    "unavailable": `\u{39C}\u{3B7} \u{3B4}\u{3B9}\u{3B1}\u{3B8}\u{3AD}\u{3C3}\u{3B9}\u{3BC}\u{3BF}, \u{3B1}\u{3BD}\u{3AC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7} \u{3B3}\u{3B9}\u{3B1} \u{3BB}\u{3B5}\u{3C0}\u{3C4}\u{3BF}\u{3BC}\u{3AD}\u{3C1}\u{3B5}\u{3B9}\u{3B5}\u{3C2}`
};


var $de5da9cdd5bee12a$exports = {};
$de5da9cdd5bee12a$exports = {
    "moreActions": `More actions`,
    "unavailable": `Unavailable, expand for details`,
    "backButton": (args)=>`Return to ${args.prevMenuButton}`
};


var $db3723c51a085311$exports = {};
$db3723c51a085311$exports = {
    "backButton": (args)=>`Volver a ${args.prevMenuButton}`,
    "moreActions": `M\xe1s acciones`,
    "unavailable": `No disponible, ampliar para m\xe1s detalles`
};


var $5cd99c404e06eb9f$exports = {};
$5cd99c404e06eb9f$exports = {
    "backButton": (args)=>`Tagasi ${args.prevMenuButton}`,
    "moreActions": `Veel toiminguid`,
    "unavailable": `Pole k\xe4ttesaadav, \xfcksikasjade vaatamiseks laiendage`
};


var $65f73c6fde514402$exports = {};
$65f73c6fde514402$exports = {
    "backButton": (args)=>`Palaa kohtaan ${args.prevMenuButton}`,
    "moreActions": `Lis\xe4\xe4 toimintoja`,
    "unavailable": `Ei saatavilla, laajenna saadaksesi lis\xe4tietoja`
};


var $0f0e6467596070ec$exports = {};
$0f0e6467596070ec$exports = {
    "backButton": (args)=>`Retour vers ${args.prevMenuButton}`,
    "moreActions": `Autres actions`,
    "unavailable": `Indisponible, d\xe9velopper pour plus de d\xe9tails`
};


var $93c080405bcb117f$exports = {};
$93c080405bcb117f$exports = {
    "backButton": (args)=>`\u{5D7}\u{5D6}\u{5D5}\u{5E8} \u{5D0}\u{5DC} ${args.prevMenuButton}`,
    "moreActions": `\u{5E4}\u{5E2}\u{5D5}\u{5DC}\u{5D5}\u{5EA} \u{5E0}\u{5D5}\u{5E1}\u{5E4}\u{5D5}\u{5EA}`,
    "unavailable": `\u{5DC}\u{5D0} \u{5D6}\u{5DE}\u{5D9}\u{5DF}, \u{5D4}\u{5E8}\u{5D7}\u{5D1} \u{5DC}\u{5E4}\u{5E8}\u{5D8}\u{5D9}\u{5DD}`
};


var $4c9dcf87f189563f$exports = {};
$4c9dcf87f189563f$exports = {
    "backButton": (args)=>`Povratak na ${args.prevMenuButton}`,
    "moreActions": `Dodatne radnje`,
    "unavailable": `Nije dostupno, pro\u{161}iri za detalje`
};


var $9be03138870991df$exports = {};
$9be03138870991df$exports = {
    "backButton": (args)=>`Vissza ide: ${args.prevMenuButton}`,
    "moreActions": `Tov\xe1bbi lehet\u{151}s\xe9gek`,
    "unavailable": `Nem \xe9rhet\u{151} el, a r\xe9szletek\xe9rt bontsa ki`
};


var $ad8c9cad3dbd650f$exports = {};
$ad8c9cad3dbd650f$exports = {
    "backButton": (args)=>`Torna a ${args.prevMenuButton}`,
    "moreActions": `Altre azioni`,
    "unavailable": `Non disponibile, espandi per i dettagli`
};


var $bc78ecf2de5c1277$exports = {};
$bc78ecf2de5c1277$exports = {
    "backButton": (args)=>`${args.prevMenuButton} \u{306B}\u{623B}\u{308B}`,
    "moreActions": `\u{305D}\u{306E}\u{4ED6}\u{306E}\u{30A2}\u{30AF}\u{30B7}\u{30E7}\u{30F3}`,
    "unavailable": `\u{5229}\u{7528}\u{3067}\u{304D}\u{307E}\u{305B}\u{3093}\u{3002}\u{8A73}\u{3057}\u{304F}\u{306F}\u{3001}\u{5C55}\u{958B}\u{3057}\u{3066}\u{78BA}\u{8A8D}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}`
};


var $e1819c2136902bf7$exports = {};
$e1819c2136902bf7$exports = {
    "backButton": (args)=>`${args.prevMenuButton}(\u{C73C})\u{B85C} \u{B3CC}\u{C544}\u{AC00}\u{AE30}`,
    "moreActions": `\u{AE30}\u{D0C0} \u{C561}\u{C158}`,
    "unavailable": `\u{C0AC}\u{C6A9}\u{D560} \u{C218} \u{C5C6}\u{C74C}, \u{C790}\u{C138}\u{D788} \u{BCF4}\u{B824}\u{BA74} \u{D3BC}\u{CE58}\u{AE30}`
};


var $99b345867a868892$exports = {};
$99b345867a868892$exports = {
    "backButton": (args)=>`Gr\u{12F}\u{17E}ti \u{12F} ${args.prevMenuButton}`,
    "moreActions": `Daugiau veiksm\u{173}`,
    "unavailable": `Nepasiekiama, nor\u{117}dami gauti daugiau informacijos, i\u{161}skleiskite`
};


var $5f3754867e416768$exports = {};
$5f3754867e416768$exports = {
    "backButton": (args)=>`Atgriezties uz ${args.prevMenuButton}`,
    "moreActions": `Citas darb\u{12B}bas`,
    "unavailable": `Nav pieejams, izv\u{113}rsiet, lai skat\u{12B}tu s\u{12B}k\u{101}ku inform\u{101}ciju`
};


var $68ce88a369285902$exports = {};
$68ce88a369285902$exports = {
    "backButton": (args)=>`G\xe5 tilbake til ${args.prevMenuButton}`,
    "moreActions": `Flere handlinger`,
    "unavailable": `Utilgjengelig, utvid for detaljer`
};


var $e9243a5fd645a2cf$exports = {};
$e9243a5fd645a2cf$exports = {
    "backButton": (args)=>`Terug naar ${args.prevMenuButton}`,
    "moreActions": `Meer handelingen`,
    "unavailable": `Niet beschikbaar, uitvouwen voor meer informatie`
};


var $ab29dff56735387a$exports = {};
$ab29dff56735387a$exports = {
    "backButton": (args)=>`Wr\xf3\u{107} do: ${args.prevMenuButton}`,
    "moreActions": `Wi\u{119}cej akcji`,
    "unavailable": `Niedost\u{119}pne, rozwi\u{144}, aby zobaczy\u{107} szczeg\xf3\u{142}y`
};


var $d943521233798059$exports = {};
$d943521233798059$exports = {
    "backButton": (args)=>`Retornar a ${args.prevMenuButton}`,
    "moreActions": `Mais a\xe7\xf5es`,
    "unavailable": `Indispon\xedvel. Expanda para ver os detalhes`
};


var $3ad4dfd69f313220$exports = {};
$3ad4dfd69f313220$exports = {
    "backButton": (args)=>`Voltar ao ${args.prevMenuButton}`,
    "moreActions": `Mais a\xe7\xf5es`,
    "unavailable": `Indispon\xedvel, expandir para mais detalhes`
};


var $22fbf25776bcbdd5$exports = {};
$22fbf25776bcbdd5$exports = {
    "backButton": (args)=>`Reveni\u{21B}i la ${args.prevMenuButton}`,
    "moreActions": `Mai multe ac\u{21B}iuni`,
    "unavailable": `Indisponibil, extinde\u{21B}i pentru detalii`
};


var $ae7dddfad0448b8a$exports = {};
$ae7dddfad0448b8a$exports = {
    "backButton": (args)=>`\u{412}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{44C}\u{441}\u{44F} \u{43A} ${args.prevMenuButton}`,
    "moreActions": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{434}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{44F}`,
    "unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}, \u{440}\u{430}\u{437}\u{432}\u{435}\u{440}\u{43D}\u{438}\u{442}\u{435} \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{434}\u{440}\u{43E}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{435}\u{439}`
};


var $3a572e5fc81706d7$exports = {};
$3a572e5fc81706d7$exports = {
    "backButton": (args)=>`Sp\xe4\u{165} na ${args.prevMenuButton}`,
    "moreActions": `\u{10E}al\u{161}ie akcie`,
    "unavailable": `Nedostupn\xe9, rozba\u{13E}te podrobnosti`
};


var $f510599a6178d1bd$exports = {};
$f510599a6178d1bd$exports = {
    "backButton": (args)=>`Nazaj na ${args.prevMenuButton}`,
    "moreActions": `Ve\u{10D} mo\u{17E}nosti`,
    "unavailable": `Ni na voljo, raz\u{161}irite za podrobnosti`
};


var $931fd402ea71f56a$exports = {};
$931fd402ea71f56a$exports = {
    "backButton": (args)=>`Povratak na ${args.prevMenuButton}`,
    "moreActions": `Dodatne radnje`,
    "unavailable": `Nije dostupno, pro\u{161}irite za detalje`
};


var $afa6d5819988437d$exports = {};
$afa6d5819988437d$exports = {
    "backButton": (args)=>`\xc5terg\xe5 till ${args.prevMenuButton}`,
    "moreActions": `Fler \xe5tg\xe4rder`,
    "unavailable": `Ej tillg\xe4nglig, expandera f\xf6r mer information`
};


var $6ef9c252e9fbc070$exports = {};
$6ef9c252e9fbc070$exports = {
    "backButton": (args)=>`Geri d\xf6n: ${args.prevMenuButton}`,
    "moreActions": `Daha fazla eylem`,
    "unavailable": `Kullan\u{131}lam\u{131}yor, ayr\u{131}nt\u{131}lar\u{131} g\xf6rmek i\xe7in geni\u{15F}letin`
};


var $9a5e4d563d152847$exports = {};
$9a5e4d563d152847$exports = {
    "backButton": (args)=>`\u{41F}\u{43E}\u{432}\u{435}\u{440}\u{43D}\u{443}\u{442}\u{438}\u{441}\u{44F} \u{434}\u{43E} ${args.prevMenuButton}`,
    "moreActions": `\u{411}\u{456}\u{43B}\u{44C}\u{448}\u{435} \u{434}\u{456}\u{439}`,
    "unavailable": `\u{41D}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{43D}\u{43E}, \u{440}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{456}\u{442}\u{44C} \u{434}\u{43B}\u{44F} \u{434}\u{43E}\u{43A}\u{43B}\u{430}\u{434}\u{43D}\u{456}\u{448}\u{43E}\u{457} \u{456}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{457}`
};


var $57bb191f18e8be40$exports = {};
$57bb191f18e8be40$exports = {
    "backButton": (args)=>`\u{8FD4}\u{56DE} ${args.prevMenuButton}`,
    "moreActions": `\u{66F4}\u{591A}\u{64CD}\u{4F5C}`,
    "unavailable": `\u{4E0D}\u{53EF}\u{7528}\u{FF0C}\u{5C55}\u{5F00}\u{4EE5}\u{67E5}\u{770B}\u{8BE6}\u{7EC6}\u{4FE1}\u{606F}`
};


var $56f3d9ca2967952d$exports = {};
$56f3d9ca2967952d$exports = {
    "backButton": (args)=>`\u{8FD4}\u{56DE} ${args.prevMenuButton}`,
    "moreActions": `\u{66F4}\u{591A}\u{52D5}\u{4F5C}`,
    "unavailable": `\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{FF0C}\u{5C55}\u{958B}\u{4EE5}\u{53D6}\u{5F97}\u{8A73}\u{7D30}\u{8CC7}\u{6599}`
};


$90339528ca3fdd88$exports = {
    "ar-AE": $9c47fa309a7d4d43$exports,
    "bg-BG": $4cd8d8b72a119260$exports,
    "cs-CZ": $10556a59bf2ddefc$exports,
    "da-DK": $c31b6134a3770ee4$exports,
    "de-DE": $16c606e9b72a71c3$exports,
    "el-GR": $055104befa589c0a$exports,
    "en-US": $de5da9cdd5bee12a$exports,
    "es-ES": $db3723c51a085311$exports,
    "et-EE": $5cd99c404e06eb9f$exports,
    "fi-FI": $65f73c6fde514402$exports,
    "fr-FR": $0f0e6467596070ec$exports,
    "he-IL": $93c080405bcb117f$exports,
    "hr-HR": $4c9dcf87f189563f$exports,
    "hu-HU": $9be03138870991df$exports,
    "it-IT": $ad8c9cad3dbd650f$exports,
    "ja-JP": $bc78ecf2de5c1277$exports,
    "ko-KR": $e1819c2136902bf7$exports,
    "lt-LT": $99b345867a868892$exports,
    "lv-LV": $5f3754867e416768$exports,
    "nb-NO": $68ce88a369285902$exports,
    "nl-NL": $e9243a5fd645a2cf$exports,
    "pl-PL": $ab29dff56735387a$exports,
    "pt-BR": $d943521233798059$exports,
    "pt-PT": $3ad4dfd69f313220$exports,
    "ro-RO": $22fbf25776bcbdd5$exports,
    "ru-RU": $ae7dddfad0448b8a$exports,
    "sk-SK": $3a572e5fc81706d7$exports,
    "sl-SI": $f510599a6178d1bd$exports,
    "sr-SP": $931fd402ea71f56a$exports,
    "sv-SE": $afa6d5819988437d$exports,
    "tr-TR": $6ef9c252e9fbc070$exports,
    "uk-UA": $9a5e4d563d152847$exports,
    "zh-CN": $57bb191f18e8be40$exports,
    "zh-TW": $56f3d9ca2967952d$exports
};



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 














function $48fb8f5e1202c980$export$2ce376c2cc3355c8(props) {
    let { item: item, state: state, isVirtualized: isVirtualized, onAction: onAction } = props;
    let { closeOnSelect: closeOnSelect } = (0, $d94604d52c3e3feb$export$21c7ab35b39f78ec)();
    let { rendered: rendered, key: key } = item;
    let stringFormatter = (0, $9SHwR$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($90339528ca3fdd88$exports))), "@react-spectrum/menu");
    let { direction: direction } = (0, $9SHwR$useLocale)();
    let submenuTriggerContext = (0, $d94604d52c3e3feb$export$dc2161044aa0b36d)();
    let { triggerRef: triggerRef, ...submenuTriggerProps } = submenuTriggerContext || {};
    let isSubmenuTrigger = !!submenuTriggerContext;
    let isUnavailable;
    let ElementType = item.props.href ? "a" : "div";
    if (isSubmenuTrigger) isUnavailable = submenuTriggerContext.isUnavailable;
    let isDisabled = state.disabledKeys.has(key);
    let isSelectable = !isSubmenuTrigger && state.selectionManager.selectionMode !== "none";
    let isSelected = isSelectable && state.selectionManager.isSelected(key);
    let itemref = (0, $9SHwR$useRef)(null);
    let ref = (0, $9SHwR$useObjectRef)((0, $9SHwR$useMemo)(()=>(0, $9SHwR$mergeRefs)(itemref, triggerRef), [
        itemref,
        triggerRef
    ]));
    let { menuItemProps: menuItemProps, labelProps: labelProps, descriptionProps: descriptionProps, keyboardShortcutProps: keyboardShortcutProps } = (0, $9SHwR$useMenuItem)({
        isSelected: isSelected,
        isDisabled: isDisabled,
        "aria-label": item["aria-label"],
        key: key,
        closeOnSelect: closeOnSelect,
        isVirtualized: isVirtualized,
        onAction: onAction,
        ...submenuTriggerProps
    }, state, ref);
    let endId = (0, $9SHwR$useSlotId)();
    let endProps = {};
    if (endId) {
        endProps.id = endId;
        menuItemProps["aria-describedby"] = [
            menuItemProps["aria-describedby"],
            endId
        ].filter(Boolean).join(" ");
    }
    let contents = typeof rendered === "string" ? /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$Text), null, rendered) : rendered;
    return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$FocusRing), {
        focusRingClass: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "focus-ring")
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement(ElementType, {
        ...menuItemProps,
        ref: ref,
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-item", {
            "is-disabled": isDisabled,
            "is-selected": isSelected,
            "is-selectable": isSelectable,
            "is-open": submenuTriggerProps.isOpen
        })
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$Grid), {
        UNSAFE_className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-itemGrid")
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$ClearSlots), null, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$SlotProvider), {
        slots: {
            text: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-itemLabel"],
                ...labelProps
            },
            end: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-end"],
                ...endProps
            },
            icon: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-icon"],
                size: "S"
            },
            description: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-description"],
                ...descriptionProps
            },
            keyboard: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-keyboard"],
                ...keyboardShortcutProps
            },
            chevron: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-chevron"],
                size: "S"
            }
        }
    }, contents, isSelected && /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$spectrumiconsuiCheckmarkMedium), {
        slot: "checkmark",
        UNSAFE_className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-checkmark")
    }), isUnavailable && /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$spectrumiconsworkflowInfoOutline), {
        slot: "end",
        size: "XS",
        alignSelf: "center",
        "aria-label": stringFormatter.format("unavailable")
    }), isUnavailable == null && isSubmenuTrigger && (direction === "rtl" ? /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$spectrumiconsworkflowChevronLeft), {
        slot: "chevron"
    }) : /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$spectrumiconsworkflowChevronRight), {
        slot: "chevron"
    })))))));
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






function $b966e606890cc5ca$export$4b1545b4f2016d26(props) {
    var _filter_at;
    let { item: item, state: state, onAction: onAction } = props;
    let { itemProps: itemProps, headingProps: headingProps, groupProps: groupProps } = (0, $9SHwR$useMenuSection)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    let { separatorProps: separatorProps } = (0, $9SHwR$useSeparator)({
        elementType: "div"
    });
    let firstSectionKey = state.collection.getFirstKey();
    let lastSectionKey = (_filter_at = [
        ...state.collection
    ].filter((node)=>node.type === "section").at(-1)) === null || _filter_at === void 0 ? void 0 : _filter_at.key;
    let sectionIsFirst = firstSectionKey === item.key && state.collection.getFirstKey() === firstSectionKey;
    let sectionIsLast = lastSectionKey === item.key && state.collection.getItem(state.collection.getLastKey()).parentKey === lastSectionKey;
    return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$Fragment), null, item.key !== state.collection.getFirstKey() && /*#__PURE__*/ (0, $9SHwR$react).createElement("div", {
        ...separatorProps,
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-divider")
    }), /*#__PURE__*/ (0, $9SHwR$react).createElement("div", itemProps, item.rendered && /*#__PURE__*/ (0, $9SHwR$react).createElement("span", {
        ...headingProps,
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-sectionHeading")
    }, item.rendered), /*#__PURE__*/ (0, $9SHwR$react).createElement("div", {
        ...groupProps,
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu", {
            "spectrum-Menu-section--noHeading": item.rendered == null,
            "spectrum-Menu-section--isFirst": sectionIsFirst,
            "spectrum-Menu-section--isLast": sectionIsLast
        })
    }, [
        ...(0, $9SHwR$getChildNodes)(item, state.collection)
    ].map((node)=>{
        let item = /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $48fb8f5e1202c980$export$2ce376c2cc3355c8), {
            key: node.key,
            item: node,
            state: state,
            onAction: onAction
        });
        if (node.wrapper) item = node.wrapper(item);
        return item;
    }))));
}









function $49b26f4b606348f6$var$Menu(props, ref) {
    let isSubmenu = true;
    let contextProps = (0, $9SHwR$useContext)((0, $d94604d52c3e3feb$export$c7e742effb1c51e2));
    let parentMenuContext = (0, $d94604d52c3e3feb$export$efa3856fc0e85e7f)();
    let { rootMenuTriggerState: rootMenuTriggerState, state: parentMenuTreeState } = parentMenuContext || {
        rootMenuTriggerState: contextProps.state
    };
    if (!parentMenuContext) isSubmenu = false;
    let completeProps = {
        ...(0, $9SHwR$mergeProps)(contextProps, props)
    };
    let domRef = (0, $9SHwR$useDOMRef)(ref);
    let [popoverContainer, setPopoverContainer] = (0, $9SHwR$useState)(null);
    let trayContainerRef = (0, $9SHwR$useRef)(null);
    let state = (0, $9SHwR$useTreeState)(completeProps);
    let submenuRef = (0, $9SHwR$useRef)(null);
    let { menuProps: menuProps } = (0, $9SHwR$useMenu)(completeProps, state, domRef);
    let { styleProps: styleProps } = (0, $9SHwR$useStyleProps)(completeProps);
    (0, $9SHwR$useSyncRef)(contextProps, domRef);
    let [leftOffset, setLeftOffset] = (0, $9SHwR$useState)({
        left: 0
    });
    let prevPopoverContainer = (0, $9SHwR$useRef)(null);
    (0, $9SHwR$useEffect)(()=>{
        if (popoverContainer && prevPopoverContainer.current !== popoverContainer && leftOffset.left === 0) {
            prevPopoverContainer.current = popoverContainer;
            let { left: left } = popoverContainer.getBoundingClientRect();
            setLeftOffset({
                left: -1 * left
            });
        }
    }, [
        leftOffset,
        popoverContainer
    ]);
    var _contextProps_submenuLevel;
    let menuLevel = (_contextProps_submenuLevel = contextProps.submenuLevel) !== null && _contextProps_submenuLevel !== void 0 ? _contextProps_submenuLevel : -1;
    let hasOpenSubmenu = state.collection.getItem(rootMenuTriggerState === null || rootMenuTriggerState === void 0 ? void 0 : rootMenuTriggerState.UNSTABLE_expandedKeysStack[menuLevel + 1]) != null;
    (0, $9SHwR$useInteractOutside)({
        ref: domRef,
        onInteractOutside: (e)=>{
            var _trayContainerRef_current;
            if (!(popoverContainer === null || popoverContainer === void 0 ? void 0 : popoverContainer.contains(e.target)) && !((_trayContainerRef_current = trayContainerRef.current) === null || _trayContainerRef_current === void 0 ? void 0 : _trayContainerRef_current.contains(e.target))) rootMenuTriggerState.close();
        },
        isDisabled: isSubmenu || !hasOpenSubmenu
    });
    // TODO: add slide transition
    return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $d94604d52c3e3feb$export$24aad8519b95b41b).Provider, {
        value: {
            popoverContainer: popoverContainer,
            trayContainerRef: trayContainerRef,
            menu: domRef,
            submenu: submenuRef,
            rootMenuTriggerState: rootMenuTriggerState,
            state: state
        }
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement("div", {
        style: {
            height: hasOpenSubmenu ? "100%" : undefined
        },
        ref: trayContainerRef
    }), /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$FocusScope), null, /*#__PURE__*/ (0, $9SHwR$react).createElement($49b26f4b606348f6$export$3dfe97b5c32d8d8c, {
        onBackButtonPress: contextProps.onBackButtonPress,
        hasOpenSubmenu: hasOpenSubmenu,
        isSubmenu: isSubmenu,
        parentMenuTreeState: parentMenuTreeState,
        rootMenuTriggerState: rootMenuTriggerState
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement("div", {
        ...menuProps,
        style: (0, $9SHwR$mergeProps)(styleProps.style, menuProps.style),
        ref: domRef,
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu", styleProps.className)
    }, [
        ...state.collection
    ].map((item)=>{
        if (item.type === "section") return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $b966e606890cc5ca$export$4b1545b4f2016d26), {
            key: item.key,
            item: item,
            state: state,
            onAction: completeProps.onAction
        });
        let menuItem = /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $48fb8f5e1202c980$export$2ce376c2cc3355c8), {
            key: item.key,
            item: item,
            state: state,
            onAction: completeProps.onAction
        });
        if (item.wrapper) menuItem = item.wrapper(menuItem);
        return menuItem;
    }))), (rootMenuTriggerState === null || rootMenuTriggerState === void 0 ? void 0 : rootMenuTriggerState.isOpen) && /*#__PURE__*/ (0, $9SHwR$react).createElement("div", {
        ref: setPopoverContainer,
        style: {
            width: "100vw",
            position: "absolute",
            top: -5,
            ...leftOffset
        }
    })));
}
function $49b26f4b606348f6$export$3dfe97b5c32d8d8c(props) {
    var _parentMenuTreeState_collection_getItem;
    let { children: children, isSubmenu: isSubmenu, hasOpenSubmenu: hasOpenSubmenu, parentMenuTreeState: parentMenuTreeState, rootMenuTriggerState: rootMenuTriggerState, onBackButtonPress: onBackButtonPress, wrapperKeyDown: wrapperKeyDown } = props;
    let stringFormatter = (0, $9SHwR$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($90339528ca3fdd88$exports))), "@react-spectrum/menu");
    let backButtonText = parentMenuTreeState === null || parentMenuTreeState === void 0 ? void 0 : (_parentMenuTreeState_collection_getItem = parentMenuTreeState.collection.getItem(rootMenuTriggerState === null || rootMenuTriggerState === void 0 ? void 0 : rootMenuTriggerState.UNSTABLE_expandedKeysStack.slice(-1)[0])) === null || _parentMenuTreeState_collection_getItem === void 0 ? void 0 : _parentMenuTreeState_collection_getItem.textValue;
    let backButtonLabel = stringFormatter.format("backButton", {
        prevMenuButton: backButtonText
    });
    let headingId = (0, $9SHwR$useSlotId)();
    let isMobile = (0, $9SHwR$useIsMobileDevice)();
    let { direction: direction } = (0, $9SHwR$useLocale)();
    return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$react).Fragment, null, /*#__PURE__*/ (0, $9SHwR$react).createElement("div", {
        role: headingId ? "dialog" : undefined,
        "aria-labelledby": headingId,
        "aria-hidden": isMobile && hasOpenSubmenu,
        "data-testid": "menu-wrapper",
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-wrapper", {
            "spectrum-Menu-wrapper--isMobile": isMobile,
            "is-expanded": hasOpenSubmenu
        })
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement("div", {
        role: "presentation",
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Submenu-wrapper"),
        onKeyDown: wrapperKeyDown
    }, isMobile && isSubmenu && !hasOpenSubmenu && /*#__PURE__*/ (0, $9SHwR$react).createElement("div", {
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Submenu-headingWrapper")
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$ActionButton), {
        "aria-label": backButtonLabel,
        isQuiet: true,
        onPress: onBackButtonPress
    }, direction === "rtl" ? /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$spectrumiconsuiArrowDownSmall), {
        UNSAFE_style: {
            rotate: "270deg"
        }
    }) : /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$spectrumiconsuiArrowDownSmall), {
        UNSAFE_style: {
            rotate: "90deg"
        }
    })), /*#__PURE__*/ (0, $9SHwR$react).createElement("h1", {
        id: headingId,
        className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Submenu-heading")
    }, backButtonText)), children)));
}
/**
 * Menus display a list of actions or options that a user can choose.
 */ // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const $49b26f4b606348f6$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $9SHwR$react).forwardRef($49b26f4b606348f6$var$Menu);


/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 








function $43fa9949e6af393d$var$ActionMenu(props, ref) {
    props = (0, $9SHwR$useSlotProps)(props, "actionMenu");
    let stringFormatter = (0, $9SHwR$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($90339528ca3fdd88$exports))), "@react-spectrum/menu");
    let buttonProps = (0, $9SHwR$filterDOMProps)(props, {
        labelable: true
    });
    if (buttonProps["aria-label"] === undefined) buttonProps["aria-label"] = stringFormatter.format("moreActions");
    return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $aa0b855f135b86e3$export$27d2ad3c5815583e), {
        isOpen: props.isOpen,
        defaultOpen: props.defaultOpen,
        onOpenChange: props.onOpenChange,
        align: props.align,
        direction: props.direction,
        shouldFlip: props.shouldFlip
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$ActionButton), {
        ref: ref,
        ...props,
        ...buttonProps
    }, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$spectrumiconsworkflowMore), null)), /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $49b26f4b606348f6$export$d9b273488cd8ce6f), {
        children: props.children,
        items: props.items,
        disabledKeys: props.disabledKeys,
        onAction: props.onAction
    }));
}
/**
 * ActionMenu combines an ActionButton with a Menu for simple "more actions" use cases.
 */ const $43fa9949e6af393d$export$ed57a210b9d13bb6 = /*#__PURE__*/ (0, $9SHwR$forwardRef)($43fa9949e6af393d$var$ActionMenu);


/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $c487b1d738ebeac2$exports = {};

$parcel$export($c487b1d738ebeac2$exports, "react-spectrum-ContextualHelp-button", () => $c487b1d738ebeac2$export$20d9583c9f1529c1, (v) => $c487b1d738ebeac2$export$20d9583c9f1529c1 = v);
$parcel$export($c487b1d738ebeac2$exports, "react-spectrum-ContextualHelp-content", () => $c487b1d738ebeac2$export$a1f805890cf58c4, (v) => $c487b1d738ebeac2$export$a1f805890cf58c4 = v);
$parcel$export($c487b1d738ebeac2$exports, "react-spectrum-ContextualHelp-dialog", () => $c487b1d738ebeac2$export$ab2d873674d20d28, (v) => $c487b1d738ebeac2$export$ab2d873674d20d28 = v);
$parcel$export($c487b1d738ebeac2$exports, "react-spectrum-ContextualHelp-dialog--isMobile", () => $c487b1d738ebeac2$export$a438776606a9a3cc, (v) => $c487b1d738ebeac2$export$a438776606a9a3cc = v);
$parcel$export($c487b1d738ebeac2$exports, "react-spectrum-ContextualHelp-footer", () => $c487b1d738ebeac2$export$d901bc3fa82b87a6, (v) => $c487b1d738ebeac2$export$d901bc3fa82b87a6 = v);
var $c487b1d738ebeac2$export$20d9583c9f1529c1;
var $c487b1d738ebeac2$export$a1f805890cf58c4;
var $c487b1d738ebeac2$export$ab2d873674d20d28;
var $c487b1d738ebeac2$export$a438776606a9a3cc;
var $c487b1d738ebeac2$export$d901bc3fa82b87a6;
$c487b1d738ebeac2$export$20d9583c9f1529c1 = `L6gUaa_react-spectrum-ContextualHelp-button`;
$c487b1d738ebeac2$export$a1f805890cf58c4 = `L6gUaa_react-spectrum-ContextualHelp-content`;
$c487b1d738ebeac2$export$ab2d873674d20d28 = `L6gUaa_react-spectrum-ContextualHelp-dialog`;
$c487b1d738ebeac2$export$a438776606a9a3cc = `L6gUaa_react-spectrum-ContextualHelp-dialog--isMobile`;
$c487b1d738ebeac2$export$d901bc3fa82b87a6 = `L6gUaa_react-spectrum-ContextualHelp-footer`;











function $726fb1b478e356bf$var$ContextualHelpTrigger(props) {
    let { isUnavailable: isUnavailable = false, targetKey: targetKey } = props;
    let triggerRef = (0, $9SHwR$useRef)(null);
    let popoverRef = (0, $9SHwR$useRef)(null);
    let { popoverContainer: popoverContainer, trayContainerRef: trayContainerRef, rootMenuTriggerState: rootMenuTriggerState, menu: parentMenuRef, state: state } = (0, $d94604d52c3e3feb$export$efa3856fc0e85e7f)();
    let triggerNode = state.collection.getItem(targetKey);
    let submenuTriggerState = (0, $9SHwR$UNSTABLE_useSubmenuTriggerState)({
        triggerKey: targetKey
    }, {
        ...rootMenuTriggerState,
        ...state
    });
    let submenuRef = (0, $9SHwR$unwrapDOMRef)(popoverRef);
    let { submenuTriggerProps: submenuTriggerProps, popoverProps: popoverProps } = (0, $9SHwR$UNSTABLE_useSubmenuTrigger)({
        node: triggerNode,
        parentMenuRef: parentMenuRef,
        submenuRef: submenuRef,
        type: "dialog",
        isDisabled: !isUnavailable
    }, submenuTriggerState, triggerRef);
    let isMobile = (0, $9SHwR$useIsMobileDevice)();
    let slots = {};
    if (isUnavailable) slots = {
        dialog: {
            UNSAFE_className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($c487b1d738ebeac2$exports))), "react-spectrum-ContextualHelp-dialog", {
                "react-spectrum-ContextualHelp-dialog--isMobile": isMobile
            }, (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), {
                "spectrum-Menu-subdialog": !isMobile
            }))
        },
        content: {
            UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($c487b1d738ebeac2$exports)))["react-spectrum-ContextualHelp-content"]
        },
        footer: {
            UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($c487b1d738ebeac2$exports)))["react-spectrum-ContextualHelp-footer"]
        }
    };
    let [trigger] = (0, $9SHwR$react).Children.toArray(props.children);
    let [, content] = props.children;
    let onBlurWithin = (e)=>{
        var _popoverRef_current_UNSAFE_getDOMNode, _popoverRef_current;
        if (e.relatedTarget && popoverRef.current && !(popoverRef === null || popoverRef === void 0 ? void 0 : (_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : (_popoverRef_current_UNSAFE_getDOMNode = _popoverRef_current.UNSAFE_getDOMNode()) === null || _popoverRef_current_UNSAFE_getDOMNode === void 0 ? void 0 : _popoverRef_current_UNSAFE_getDOMNode.contains(e.relatedTarget)) && !(e.relatedTarget === triggerRef.current && (0, $9SHwR$getInteractionModality)() === "pointer")) {
            if (submenuTriggerState.isOpen) submenuTriggerState.close();
        }
    };
    let overlay;
    let tray;
    let onBackButtonPress = ()=>{
        submenuTriggerState.close();
        if (parentMenuRef.current && !parentMenuRef.current.contains(document.activeElement)) parentMenuRef.current.focus();
    };
    let [offset, setOffset] = (0, $9SHwR$useState)(0);
    (0, $9SHwR$useLayoutEffect)(()=>{
        if (parentMenuRef.current) {
            var _window_getComputedStyle, _window;
            let offset = (_window = window) === null || _window === void 0 ? void 0 : (_window_getComputedStyle = _window.getComputedStyle(parentMenuRef === null || parentMenuRef === void 0 ? void 0 : parentMenuRef.current)) === null || _window_getComputedStyle === void 0 ? void 0 : _window_getComputedStyle.getPropertyValue("--spectrum-submenu-offset-distance");
            if (offset !== "") setOffset(-1 * parseInt(offset, 10));
        }
    }, [
        parentMenuRef
    ]);
    if (isMobile) {
        delete submenuTriggerProps.onBlur;
        delete submenuTriggerProps.onHoverChange;
        if (trayContainerRef.current && submenuTriggerState.isOpen) {
            let subDialogKeyDown = (e)=>{
                switch(e.key){
                    case "Escape":
                        e.stopPropagation();
                        onBackButtonPress();
                        break;
                }
            };
            tray = /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $49b26f4b606348f6$export$3dfe97b5c32d8d8c), {
                isSubmenu: true,
                parentMenuTreeState: state,
                rootMenuTriggerState: rootMenuTriggerState,
                wrapperKeyDown: subDialogKeyDown,
                onBackButtonPress: onBackButtonPress
            }, content);
            overlay = /*#__PURE__*/ (0, $9SHwR$reactdom).createPortal(tray, trayContainerRef.current);
        }
    } else {
        let onDismissButtonPress = ()=>{
            var _parentMenuRef_current;
            submenuTriggerState.close();
            (_parentMenuRef_current = parentMenuRef.current) === null || _parentMenuRef_current === void 0 ? void 0 : _parentMenuRef_current.focus();
        };
        overlay = /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$Popover), {
            ...popoverProps,
            UNSAFE_style: {
                clipPath: "unset",
                overflow: "visible",
                filter: "unset",
                borderWidth: "0px"
            },
            UNSAFE_className: (0, $9SHwR$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Submenu-popover"),
            onDismissButtonPress: onDismissButtonPress,
            onBlurWithin: onBlurWithin,
            container: popoverContainer,
            state: submenuTriggerState,
            ref: popoverRef,
            triggerRef: triggerRef,
            placement: "end top",
            containerPadding: 0,
            crossOffset: offset,
            offset: offset,
            hideArrow: true,
            enableBothDismissButtons: true
        }, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$FocusScope), {
            restoreFocus: true
        }, content));
    }
    return /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$react).Fragment, null, /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $d94604d52c3e3feb$export$8d97fe02339fc0e3).Provider, {
        value: {
            isUnavailable: isUnavailable,
            triggerRef: triggerRef,
            ...submenuTriggerProps
        }
    }, trigger), /*#__PURE__*/ (0, $9SHwR$react).createElement((0, $9SHwR$SlotProvider), {
        slots: slots
    }, submenuTriggerState.isOpen && overlay));
}
$726fb1b478e356bf$var$ContextualHelpTrigger.getCollectionNode = function* getCollectionNode(props) {
    let childArray = [];
    (0, $9SHwR$react).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, $9SHwR$react).isValidElement(child)) childArray.push(child);
    });
    let [trigger] = childArray;
    let [, content] = props.children;
    yield {
        element: /*#__PURE__*/ (0, $9SHwR$react).cloneElement(trigger, {
            ...trigger.props,
            hasChildItems: true,
            isTrigger: true
        }),
        wrapper: (element)=>/*#__PURE__*/ (0, $9SHwR$react).createElement($726fb1b478e356bf$var$ContextualHelpTrigger, {
                key: element.key,
                targetKey: element.key,
                ...props
            }, element, content)
    };
};
let $726fb1b478e356bf$export$5413b169fff83e61 = $726fb1b478e356bf$var$ContextualHelpTrigger;





export {$aa0b855f135b86e3$export$27d2ad3c5815583e as MenuTrigger, $3f13e15cf95c3893$export$ecabc99eeffab7ca as SubmenuTrigger, $49b26f4b606348f6$export$d9b273488cd8ce6f as Menu, $43fa9949e6af393d$export$ed57a210b9d13bb6 as ActionMenu, $726fb1b478e356bf$export$5413b169fff83e61 as ContextualHelpTrigger, $5ae296f2d6923e14$re_export$Item as Item, $5ae296f2d6923e14$re_export$Section as Section};
//# sourceMappingURL=module.js.map
